module.exports = __webpack_public_path__ + "static/media/INZ1169.f7ca2ea8.pdf";